module.exports = __webpack_public_path__ + "img/037.4e2f5129.png";